module.exports = __webpack_public_path__ + "img/cim_feher.3804fdcc.svg";